import { CREATE_ROLE, GET_ROLE, ROLE_DETAIL, ROLE_ERROR, ROLE_MODULES } from "../types";

const initialState = {
  response: null,
  detail: false,
  create: false,
};

export function roleReducer(state = initialState, action) {
  switch (action.type) {
    case GET_ROLE:
      return {
        ...state,
        create: false,
        detail: false,
        response: action.payload,
      };

    case CREATE_ROLE:
      return {
        ...state,
        create: true,
        detail: false,
        response: action.payload,
      };

    case ROLE_DETAIL:
      return {
        ...state,
        create: false,
        detail: true,
        response: action.payload,
      };

    case ROLE_ERROR:
      return {
        ...state,
        detail: true,
        create: true,
        response: action.payload,
      };

    default:
      return state;
  }
}
